<template>
  <div>
    <ApprovedCourses />
  </div>
</template>

<script>
import ApprovedCourses from '../../../components/academic/Advisor/ApprovedandDeniedCourses.vue'

export default {
components:{
  ApprovedCourses
}
}
</script>

<style>

</style>